import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { frameTool } from '../frame/FrameTool';
import { zoneTool } from '../zones/ZoneTool';
import { LayoutLibraryWidget } from './LayoutLibraryWidget';

export const layoutLibraryToolboxItem = ToolboxItem({
    id: 'layoutLibrary',
    label: 'Zones & Frames',
    ui: LayoutLibraryWidget,
    icon: 'deqo://icons/d2/classic-frame',
    placement: 'right',
    weight: 3050,
    tools: [zoneTool, frameTool]
});
